module.exports = __webpack_public_path__ + "img/hotel-logo.8b24ebe6.svg";